import { Phone } from '@navent-jobs/ui-kit/components/PhoneInput'
import { status, StatusType } from '../typeStatus'

export const GET_USER_ME = 'GET_USER_ME'
export const GET_USER_ME_SUCCESS = 'GET_USER_ME_SUCCESS'
export const GET_USER_ME_ERROR = 'GET_USER_ME_ERROR'

export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_RESET = 'UPDATE_PROFILE_RESET'

export interface UserType {
  id: number
  usuario: string
  tipoUsuario: string
  nombre: string
  apellido: string
  email: string
  puesto: string
  passwordActual: string
  passwordNew: string
  numeroTelefono: string
  prefijoTelefono: string
  telefono: Phone | null
}

export interface UpdateUsersType {
  status: StatusType
  invalidPassword: boolean
}
export interface UpdateProfile {
  type: typeof UPDATE_PROFILE
  payload: null
}

export interface UpdateProfileSuccess {
  type: typeof UPDATE_PROFILE_SUCCESS
  payload: null
}
export interface UpdateProfileError {
  type: typeof UPDATE_PROFILE_ERROR
  payload: boolean
}
export interface UpdateProfileReset {
  type: typeof UPDATE_PROFILE_RESET
  payload: null
}

export interface GetUserMe {
  type: typeof GET_USER_ME
  payload: UserType | null
}

export interface GetUserMeSuccess {
  type: typeof GET_USER_ME_SUCCESS
  payload: UserType | null
}

export interface GetUserMeError {
  type: typeof GET_USER_ME_ERROR
  payload: null
}

export interface MyProfileState {
  status: StatusType
  me: UserType | null
  updateProfile: {
    invalidPassword: boolean
    status: StatusType
  }
}

export const initialState: MyProfileState = {
  status: status.initial,
  me: null,
  updateProfile: {
    invalidPassword: false,
    status: status.initial,
  },
}

export type MyProfileActions =
  | GetUserMe
  | GetUserMeError
  | GetUserMeSuccess
  | UpdateProfile
  | UpdateProfileSuccess
  | UpdateProfileError
  | UpdateProfileReset
